module.exports = __webpack_public_path__ + "img/vertical_3_1_3016.050a697e.png";